<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      転職意欲
    </Header>

    <div class="desire-to-work p-3">
      <div class="py-2 mb-3">
        <dl class="rule-list">
          <dt class="text-weight-500 text-green text-size-14 mb-1 caution">
            <FeatherIcon
              icon="info"
              size="16"
              class="caution-icon"
            />「条件を聞いてみたい」「面接を受けたい」を選択した場合、スカウトメッセージや限定求人が届くことがあります
          </dt>
        </dl>
      </div>
      <CustomValidationObserver ref="vObserver" v-slot="{ handleSubmit }">
        <BForm @submit.stop.prevent>
          <div class="mt-4">
            <ValidationProvider
              v-slot="validationState"
              name="転職意欲"
              :rules="{ required: true }"
              vid="desireToWork"
            >
              <FormRadioGroup
                label="転職意欲"
                appLabelText="必須"
                name="desireToWork"
                v-model="desireToWork"
                :options="desireToWorkOptions"
                :validation-state="validationState"
              />
            </ValidationProvider>
          </div>

          <AppButton
            :block="true"
            class="mt-4"
            @click="handleSubmit(onClickSubmitButton)"
            >登録する</AppButton
          >
        </BForm>
      </CustomValidationObserver>
    </div>
  </div>
</template>

<script lang="ts">
import Header from "@/components/organisms/common/Header.vue";
import FormRadioGroup from "@/components/molecules/form/FormRadioGroup.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { orderService } from "@/app/services/OrderService";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { Component, Hook, Vue, toNative } from "vue-facing-decorator";
import { NavigationGuardNext, RouteLocation } from "vue-router";
import { masterStore } from "@/store/master";

@Component({
  components: {
    Header,
    FormRadioGroup,
    AppButton,
    FeatherIcon
  }
})
class EvaluationDesireToWork extends Vue {
  desireToWork: number | null = null;

  get desireToWorkOptions() {
    return masterStore.desireToWorks.map(desireToWork => {
      return {
        value: desireToWork.id,
        text: desireToWork.name
      };
    });
  }

  @Hook
  beforeRouteEnter(
    to: RouteLocation,
    from: RouteLocation,
    next: NavigationGuardNext
  ) {
    next(vm => {
      /**
       * 遷移前の画面が評価完了画面の場合は、お仕事一覧画面に遷移する
       * 右スワイプでのブラウザバック時に転職意欲画面へ戻ると、IDが決まらず下記のエラーとなってしまう
       * これを避けるため、戻り先として違和感のないお仕事一覧画面へ遷移する
       *  https://caitech.slack.com/archives/C03CAH7JE02/p1672992799960129
       */
      if (from.name === "ApplicationEvaluationFinished") {
        vm.$router.replace({ name: "ApplicationsList" });
      }
    });
  }

  async onClickBack() {
    await this.$router.push({ name: "ApplicationsList" });
  }
  async onClickSubmitButton() {
    this.$loading.show();
    try {
      if (this.desireToWork === null)
        throw new Error("転職意欲が入力されていません"); // 事前にvalidationが入るので、実際にはnullになることはない

      await orderService.registerDesireToWork(
        Number(this.$route.params.evaluationByWorkerId),
        this.desireToWork
      );
      await this.$router.push({
        name: "ApplicationEvaluationFinished",
        params: { applicationId: this.$route.params.applicationId }
      });
    } catch (error) {
      await showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }
}

export default toNative(EvaluationDesireToWork);
</script>

<style lang="scss" scoped>
.desire-to-work {
  .rule-list {
    padding: 12px;
    font-size: 14px;
    background-color: $primary-bg;
    border: 1px solid $yellow;
    border-radius: 4px;

    .caution {
      position: relative;
      padding-left: 22px;

      .caution-icon {
        position: absolute;
        top: 2px;
        left: 0;
      }
    }
  }
}

:deep(.radio-group__item) {
  width: 100%;
  margin: 6px;
}
</style>
